import { Button } from "@mui/material";
import { Navigate } from "react-router";

import { GqlPermissions } from "~/__generated__";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";

import usePlannerVisitRecalculateDays from "./api/usePlannerVisitRecalculateDays";
import AnasMySpaceFrills from "./components/AnasMySpaceFrills";

export default function AnaScreen() {
    const { plannerVisitRecalculateDays, loading } = usePlannerVisitRecalculateDays();

    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);
    if (!isAdmin) {
        return <Navigate to="/" replace />;
    }

    return (
        <AnasMySpaceFrills>
            <Button
                variant="contained"
                onClick={() => plannerVisitRecalculateDays()}
                sx={{
                    "@keyframes rotateAroundABit": {
                        "0%": {
                            transform: "rotate3d(1, 0, 1, 0)",
                        },
                        "50%": {
                            transform: "rotate3d(0, 1, .5, 180deg)",
                        },
                        "100%": {
                            transform: "rotate3d(1, 0, 1, 0)",
                        },
                    },
                    animation: loading ? "rotateAroundABit 1s ease-in-out infinite" : "none",
                }}
            >
                RECALCULATE VISITS
            </Button>
        </AnasMySpaceFrills>
    );
}
